/**
 * A readable message from an ApiService error (or a raw HttpErrorResponse).
 * Structured details such as `{"detail": "...", "message": "..."}` (portal
 * payment errors) are joined as "detail - message"; a plain string detail is
 * used as-is; otherwise `fallback`. Never throws on an unexpected shape.
 */
export function apiErrorMessage(err: unknown, fallback: string): string {
  const body = (err as { error?: { detail?: unknown; raw?: { detail?: unknown } } } | null)?.error;
  const detail = body?.raw?.detail ?? body?.detail;

  if (typeof detail === 'string' && detail) return detail;
  if (detail && typeof detail === 'object') {
    const { detail: inner, message } = detail as { detail?: unknown; message?: unknown };
    const parts = [inner, message].filter((p): p is string => typeof p === 'string' && !!p);
    if (parts.length) return parts.join(' - ');
  }
  return fallback;
}
